<template>
  <div class="order">
    <div class="order_title">
      {{ $t("router.adorder") }}
      <!-- <img class="order_title_img" src="@/img/init.png" alt="" /> -->
    </div>
    <!-- 这个是 -->
    <div class="condition_box">
      <div class="condition">
        <div class="seek_input_box">
          <div class="seek_text">
            {{
              roleName && roleName.includes("GAME_DEVELOPER")
                ? $t("operational_data.game")
                : $t("operational_data.app")
            }}
          </div>
          <el-select
            :disabled="gameApp.length > 0 ? false : true"
            :no-data-text="$t('operational_data.no_result')"
            class="order_win"
            :placeholder="$t('operational_data.select')"
            v-model="appNamestate"
          >
            <el-option
              v-for="(item, index) in gameApp"
              :key="index"
              :label="item.appName"
              :value="index"
            ></el-option>
          </el-select>
        </div>

        <div class="seek_input_box">
          <div class="seek_text">{{ $t("operational_data.order") }}</div>
          <input
            :placeholder="$t('operational_data.select_name')"
            v-model="orderId"
            class="seek_input TGA_INPUT"
            type="text"
          />
        </div>
        <div class="seek_input_box">
          <div class="seek_text">{{ $t("operational_data.userId") }}</div>
          <input
            :placeholder="$t('operational_data.select_id')"
            v-model="userId"
            class="seek_input TGA_INPUT"
            type="text"
          />
        </div>
      </div>
      <div class="condition_btn CU" @click="exportExcel">
        {{ $t("operational_data.data") }}
      </div>
    </div>
    <div class="condition2">
      <div class="time">
        <div class="time_text">{{ $t("operational_data.selecttime") }}</div>
        <div class="time_data">
          <!-- v-model="queryParam.id" -->
          <!-- <a-input placeholder /> -->
          <!--             :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }" -->
          <a-range-picker
            show-time
            :format="dataFormat"
            @change="onChange"
            :locale="locale"
            :disabled-date="disabledDate"
            :default-value="defaultDate"
            style="width: 320px; height: 40px"
          >
            <a-icon slot="suffixIcon" type="calendar" />
          </a-range-picker>
        </div>
      </div>
      <div class="orderstatus">
        <div class="orderstatus_text">
          {{ $t("operational_data.orderstate") }}
        </div>
        <div class="orderstatus_data">
          <!--  v-model="bank" -->
          <el-select
            class="order_win"
            :placeholder="$t('operational_data.select')"
            v-model="state"
          >
            <el-option
              v-for="(item, index) in orderstatus"
              :key="index"
              :label="item"
              :value="index"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="order_btn CU" @click="send">
        {{ $t("operational_data.send") }}
      </div>
    </div>

    <div class="gamelist_table">
      <a-config-provider>
        <template #renderEmpty style="">
          <div style="text-align: center; margin-top: 224px">
            <img src="@/img/kong.png" alt="" />
            <p>{{ $t("operational_data.no_result") }}</p>
          </div>
        </template>

        <template v-if="datalist == '' && tableloading" style="">
          <div style="text-align: center; margin-top: 224px">
            <loading></loading>
          </div>
        </template>

        <a-table
          v-if="datalist !== ''"
          @change="handleTableChange"
          :pagination="pagination"
          :scroll="{ x: true }"
          :columns="columns"
          :data-source="datalist"
          :rowKey="
            (record, index) => {
              return index;
            }
          "
        >
          <template slot="id" slot-scope="text, record, index">
            {{ 10000 - -index }}
          </template>
          <template slot="appName" slot-scope="text, record, index">
            {{ text }}
          </template>

          <template slot="checkState" slot-scope="text, record, index">
            {{ text }}
          </template>

          <template slot="version" slot-scope="text, record, index">
            {{ text }}
          </template>
          <template slot="lastModified" slot-scope="text, record, index">
            {{ text }}
          </template>
        </a-table>
      </a-config-provider>
    </div>

    <div class="" id="add" style="display: none">
      <el-table :data="tableAllData" highlight-current-row style="width: 100%">
        <template v-for="(item, index) in exportExcelArry">
          <!--  v-if="!item.formatterFlag" -->
          <el-table-column
            :prop="item.prop"
            :label="item.label"
          ></el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import "moment/locale/zh-cn";
import EN from "ant-design-vue/es/date-picker/locale/en_US";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import exportExcelCommon from "@/components/ExportExcelCommon.vue";
import loading from "@/components/loading/loading.vue";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  components: {
    loading,
  },
  data() {
    return {
      tableloading: false,
      roleName: localStorage.getItem("roleName"),
      dataFormat: "YYYY/MM/DD HH:mm:ss",
      // 开始时间
      startTime: moment().endOf("day").format(this.dataFormat),
      // 结束时间
      endTime: moment(this.startTime)
        .subtract(7, "days")
        .endOf("day")
        .format(this.dataFormat),
      // 订单号码
      orderId: "",
      // 用户的ID
      userId: "",
      // 订单的状态
      state: 0,
      offset: 0,
      count: 20,

      defaultDate: (() => {
        const endTime = moment().endOf("day");
        const startDate = moment(endTime).subtract(7, "days").startOf("day");

        return [
          startDate.format(this.dataFormat),
          endTime.format(this.dataFormat),
        ];
      })(),

      pagination: {
        defaultCurrent: 1,
        total: 0,
        pageSize: 20, //每页中显示20条数据
      },
      datalist: [],
      locale: EN,

      orderstatus: this.$t("operational_data.orderstatus"),
      columns: [
        {
          title: this.$t("operational_data.createTime"),
          dataIndex: "createTime",
          key: "createTime",
          scopedSlots: { customRender: "createTime" },
          customRender: (text, record) => {
            const time = this.NewData(text); //es6写法
            return time;
          },
        },
        {
          title: this.$t("operational_data.order"),
          dataIndex: "orderNo",
          key: "orderNo",
          // slots: { title: 'customName2' },
          // width: "25.5%",
          scopedSlots: { customRender: "orderNo" },
          customRender: (text, record) => {
            var data = text;

            return text;
          },
        },
        {
          title: this.$t("operational_data.wareName"),
          // slots: { title: 'customName3' },
          dataIndex: "wareName",
          key: "wareName",
          ellipsis: true,
          // width: "14.4%",
          scopedSlots: { customRender: "wareName" },
          customRender: (text, record) => {
            var data = text;
            if (text == "null") {
              data = this.$t("operational_data.kong");
            }
            return data;
          },
        },
        {
          title: this.$t("operational_data.wareCnt"),
          // slots: { title: 'customName4' },
          dataIndex: "wareCnt",
          key: "wareCnt",
          ellipsis: true,
          // width: "13.7%",
          customRender: (text, record) => {
            var data = text;
            return data;
          },
        },
        {
          title: this.$t("operational_data.price"),
          // slots: { title: 'customName5' },
          dataIndex: "price",
          key: "price",
          ellipsis: true,
          // width: "15.1%",
          customRender: (text, record) => {
            var data = "";
            if (text.indexOf("{") == -1) {
              data = text;
            } else {
              data = JSON.parse(text);
              data = data.unit + (data.cnt / data.ratio + "");
            }

            return data;
          },
        },
        {
          title: this.$t("operational_data.user"),
          // slots: { title: 'customName5' },
          dataIndex: "userId",
          key: "userId",
          ellipsis: true,
          // width: "15.1%",
          customRender: (text, record) => {
            var data = text;
            return data;
          },
        },
        {
          title: this.$t("operational_data.state"),
          // slots: { title: 'customName5' },
          dataIndex: "state",
          key: "state",
          ellipsis: true,
          // width: "15.1%",
          customRender: (text, record) => {
            var data = "";

            if (text == 0) {
              data = this.$t("operational_data.pay1");
            } else if (text == 1) {
              data = this.$t("operational_data.pay2");
            } else {
              data = this.$t("operational_data.pay3");
            }
            return data;
          },
        },
      ],

      //导出表格字段及formatter信息
      exportExcelArry: [
        {
          prop: "createTime",
          label: this.$t("operational_data.createTime"),
        },
        {
          prop: "orderNo",
          label: this.$t("operational_data.order"),
        },
        {
          prop: "wareName",
          label: this.$t("operational_data.wareName"),
        },
        {
          prop: "wareCnt",
          label: this.$t("operational_data.wareCnt"),
        },
        {
          prop: "price",
          label: this.$t("operational_data.price"),
        },
        {
          prop: "userId",
          label: this.$t("operational_data.user"),
        },
        {
          prop: "state",
          label: this.$t("operational_data.state"),
        },
      ],

      //导出excel表格id及excel名称
      exportExcelInfo: {
        excelId: "record-table",
        excelName: "order.xlsx",
      },
      //需要导出的table数据
      tableAllData: [],

      // APPid列表
      gameApp: [],
      appNamestate: "",
    };
  },
  created() {
    if (this.$i18n.locale == "zh") {
      moment.locale("zh-cn");
      this.locale = locale;
    } else {
      moment.locale("en_US");
      this.locale = EN;
    }
  },
  mounted() {
    var self = this;
    if (localStorage.getItem("roleName").includes("GAME_DEVELOPER")) {
      this.getGameOnlineList({
        $axios: this.$axios,
      }).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          if (data) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].name.indexOf("[") != -1) {
                data[i].name = JSON.parse(data[i].name);
                var newtext = data[i].name.find(
                  (item) => item.lang.toLowerCase() == this.$i18n.locale
                );
                if (!newtext) {
                  newtext = data[i].name[0];
                }
                data[i].appName = newtext.values;
              }
            }
            let newDate = [
              {
                appName: "All",
              },
              ...data,
            ];
            self.gameApp = newDate;
            self.appNamestate = 0;
          }

          this.send();
        }
      });
    } else {
      this.AppList({
        $axios: this.$axios,
      }).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          if (data) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].appName.indexOf("[") != -1) {
                data[i].appName = JSON.parse(data[i].appName);
                var newtext = data[i].appName.find(
                  (item) => item.lang.toLowerCase() == this.$i18n.locale
                );
                if (!newtext) {
                  newtext = data[i].appName[0];
                }
                data[i].appName = newtext.values;
              }
            }
            let newDate = [
              {
                appName: "All",
              },
              ...data,
            ];
            self.gameApp = newDate;
            console.log("self.gameApp", newDate);
            self.appNamestate = 0;
          }

          this.send();
        }
      });
    }
  },
  methods: {

    ...mapActions("game", ["AppList","getGameOnlineList", "HtTrades"]),

    async exportExcel() {
      var self = this;
      this.tableloading = true;
      let state = this.state;
      if (this.state - 1 < 0) {
        state = "";
      } else {
        if (this.orderstatus.length - 1 == state) {
          state = -1;
        } else {
          state = state - 1;
        }
      }
      const res = await this.HtTrades({
        $axios: this.$axios,
        appId: this.gameApp[this.appNamestate].appId,
        orderId: this.orderId,
        userId: this.userId,
        startTime: this.startTime.getTime(),
        endTime: this.endTime.getTime(),
        state: state,
        offset: 0,
        count: 0,
        lang: "en",
      });
      if (res.stateCode == 1) {
        var data = res.resultInfo.data;
        console.log("res--------", res);
        for (let i = 0; i < data.length; i++) {
          if (data[i].price.indexOf("{") != -1) {
            data[i].price = JSON.parse(data[i].price);
            data[i].price =
              data[i].price.unit + data[i].price.cnt / data[i].price.ratio;
          }

          data[i].createTime = this.NewData(data[i].createTime);

          if (data[i].state == 0) {
            data[i].state = this.$t("operational_data.pay1");
          } else if (data[i].state == 1) {
            data[i].state = this.$t("operational_data.pay2");
          } else {
            data[i].state = this.$t("operational_data.pay3");
          }
        }
        this.tableAllData = data;
        setTimeout(function () {
          if (self.tableAllData.length <= 0) {
            return;
          }
          var xlsxParam = { raw: true }; //转换成excel时，使用原始的格式
          var wb = XLSX.utils.table_to_book(
            document.querySelector("#add"),
            xlsxParam
          );
          var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array",
          });
          try {
            FileSaver.saveAs(
              new Blob([wbout], {
                type: "application/octet-stream;charset=utf-8",
              }),
              "order.xlsx"
            );
          } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
          }
          return wbout;
        }, 2000);
        this.tableloading = false;
      }
    },

    handleTableChange(pagination, filters, sorter) {
      this.offset = pagination.current;
      if (!this.startTime) {
        this.startTime = 0;
        this.endTime = 0;
      }
      this.appId = this.appNamestate;
      this.getlist();
    },

    // 点击查询
    send() {
      console.log(!this.startTime);
      if (!this.startTime) {
        this.startTime = 0;
        this.endTime = 0;
      }
      this.datalist = [];
      this.offset = 0;
      this.appId = this.appNamestate;
      this.getlist();
    },

    // 获取数据
    async getlist() {
      var self = this;
      this.tableloading = true;

      let state = this.state;
      console.log("this.orderstatus.length", this.orderstatus.length);
      console.log("state", state);
      if (state - 1 < 0) {
        state = "";
      } else {
        if (this.orderstatus.length - 1 == state) {
          state = -1;
        } else {
          state = state - 1;
        }
      }

      const res = await this.HtTrades({
        $axios: self.$axios,
        appId:
          this.gameApp.length <= 0
            ? "0"
            : this.gameApp[this.appNamestate].appId,
        tradId: this.orderId,
        userId: (this.userId = "" ? "0" : this.userId),
        startTime: this.startTime,
        endTime: this.endTime,
        state: state,
        offset: this.offset - 1 <= 0 ? 0 : this.offset - 1,
        count: this.count,
        lang: "en",
      });
      if (res.stateCode == 1) {
        console.log("555555", res);
        this.datalist = res.resultInfo.data;
        this.pagination.total = res.resultInfo.totalCnt;
        this.tableloading = false;
      }
    },

    moment,
    // 监听日期
    onChange(dates, dateStrings) {
      console.log("From: ", dateStrings[0], ", to: ", dateStrings[1]);
      this.startTime = new Date(dateStrings[0]).getTime();
      this.endTime = new Date(dateStrings[1]).getTime();
    },
    NewData(data) {
      var d = new Date(data);
      var year = d.getFullYear(); //年
      var month = d.getMonth() + 1; //月
      var day = d.getDate(); //日
      var hh = d.getHours(); //时
      var mm = d.getMinutes(); //分
      var ss = d.getSeconds(); //秒
      var clock = year + "-";
      if (month < 10) clock += "0";
      clock += month + "-";
      if (day < 10) clock += "0";
      clock += day + " ";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += "0";
      clock += mm + ":";
      if (ss < 10) clock += "0";
      clock += ss;
      return clock;
    },
    disabledDate(currentDate) {
      return currentDate && currentDate > moment().endOf("day");
    },
  },
};
</script>

<style scoped="scoped">
.order {
  width: 100%;
  min-height: 880px;
  /* height: 880px; */
  padding-top: 32px;
  padding-bottom: 40px;
}
.order_title {
  padding-left: 42px;
  color: #282828;
  font-size: 20px;
}
.order_title_img {
  width: 16px;
  height: 16px;
  margin-left: 19px;
}
.condition_box {
  margin-top: 33px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  background-color: #f5f7fa;
  border-bottom: solid 1px #eeeeee;
  margin-bottom: 25px;
}
.condition {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.condition_btn {
  width: 100px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #666666;
}
.seek_input_box {
  margin-right: 70px;
  display: flex;
  align-items: center;
}
.seek_text {
  margin-right: 23px;
}
.seek_input {
  width: 241px;
  height: 34px;
}
.condition2 {
  margin-top: 25px;
  padding-left: 63px;
  display: flex;
}
.time {
  display: flex;
  align-items: center;
}
.time_text {
  color: #666666;
  font-size: 14px;
  margin-right: 24px;
}
.order_win {
  width: 176px;
  height: 40px;
}
.orderstatus {
  margin-left: 70px;
  display: flex;
  align-items: center;
}
.orderstatus_text {
  color: #666666;
  font-size: 14px;
  margin-right: 24px;
}
.orderstatus_data {
}
.order_btn {
  width: 90px;
  height: 40px;
  background-color: #5b99fa;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.gamelist_table {
  margin: 25px auto 0;
  width: 1265px;
}
</style>



// WEBPACK FOOTER //
// src/components/Operational_data/adorder.vue